import BaseService from "./BaseService";

export default class SearchService extends BaseService  {
    constructor(keycloakToken, currentScope) {
      super(keycloakToken, currentScope);
  }

  async getPagesResults(searchReference) {
    return await this.getAsync(this.GetUri() + "search?reference=" + searchReference);
  }
} 